import { parse } from 'date-fns';
import { formatDate } from '@/helpers/date';
import Dte from '../respuestas/dte.model';

export type DteApi = {
  fechaVencimiento: string;
  diasPlazo: number;
  deudorExisteFintec: boolean;
  tipoDoc: string;
  noTipoDoc: string;
  nro: string;
  rutReceptor: string;
  noEmpresa: string;
  folio: string;
  feDocumento: string;
  totalReparos: string;
  mtNeto: string;
  mtExento: string;
  mtIva: string;
  mtTotal: string;
  feRecepcion: string;
  evento: string;
  codigoOtroImpto: string;
  valorOtroImpto: string;
  tasaOtroImpto: string;
  idTipoDocumento: number;
};

const convertirFormatoFecha = (fechaString: string): string => {
  // Parsear la fecha en el formato original
  const fechaOriginal = parse(fechaString, 'dd/MM/yyyy', new Date());

  // Formatear la fecha en el nuevo formato
  const fechaFormateada = formatDate(fechaOriginal);

  return fechaFormateada;
};

const dteAdapter = (data: DteApi[]): Dte[] => {
  return data.map((d) => ({
    ...d,
    feRecepcion: convertirFormatoFecha(d.feRecepcion),
    fechaVencimiento: convertirFormatoFecha(d.fechaVencimiento),
    feDocumento: convertirFormatoFecha(d.feDocumento),
    tipoDoc: Number(d.tipoDoc),
    mtNeto: Number(d.mtNeto),
    mtExento: Number(d.mtExento),
    mtIva: Number(d.mtIva),
    mtTotal: Number(d.mtTotal),
    folio: Number(d.folio),
  }));
};

export default dteAdapter;
